import React from 'react'
const Truck = () => {
  return (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.33203 1.16406H8.86536L9.97913 6.40532C9.99054 6.45901 10.0379 6.4974 10.0928 6.4974V6.4974C11.6977 6.4974 12.9987 7.7984 12.9987 9.40327V10.4974"
        stroke="black"
        strokeWidth="1.33333"
      />
      <circle cx="9.33073" cy="10.1667" r="1.66667" stroke="black" strokeWidth="1.33333" />
      <path
        d="M7.83203 10.5H0.998698L0.998698 5.83333L6.9987 5.83333V1.16667"
        stroke="black"
        strokeWidth="1.33333"
      />
      <rect x="0.332031" y="3.16406" width="3" height="1.33333" fill="black" />
    </svg>
  )
}

export default Truck
